import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';

//redux
import TransfersList from './TransfersList';

const Transfers = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Logística', icon: 'icon-map-pinned' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Transportes' links={breadcrumbLinks} icon={'icon-truck'} />
					<TransfersList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Transfers;